import { ssoApi } from "@sso/apis";
import { ApiMethodKeys, notificationsMsgs, SnackbarKeys } from "@sso/constant";
import { closeDialog } from "@sso/store/slices/dialog";
import { pushSnackbar } from "@sso/store/slices/snackbar";
import { ChangePasswordType, ForgotPasswordType, QueryParameters, ResetPasswordPayloadType } from "@sso/types";

import { Endpoints } from "../endpoints";

export const resetPasswordApi = ssoApi.injectEndpoints({
  endpoints: builder => ({
    forgotPassword: builder.mutation<void, ForgotPasswordType>({
      query: ({ email }) => ({
        url: `${Endpoints.RESET_PASSWORD}/RequestByEmail`,
        method: ApiMethodKeys.POST,
        data: email,
      }),
      onQueryStarted({ successMessage }, { dispatch, queryFulfilled }) {
        queryFulfilled.then(() => {
          dispatch(
            pushSnackbar({
              type: SnackbarKeys.SUCCESS,
              title: successMessage || notificationsMsgs.FORGOT_PASSWORD,
            }),
          );
          dispatch(closeDialog());
        });
      },
    }),
    resetPassword: builder.mutation<void, ResetPasswordPayloadType>({
      query: data => ({ url: `${Endpoints.RESET_PASSWORD}/ChangePassword`, method: ApiMethodKeys.POST, data }),
      onQueryStarted(_, { dispatch, queryFulfilled }) {
        queryFulfilled.then(() => {
          dispatch(pushSnackbar({ type: SnackbarKeys.SUCCESS, title: notificationsMsgs.RESET_PASSWORD }));
          dispatch(closeDialog());
        });
      },
    }),
    changePassword: builder.mutation<void, ChangePasswordType>({
      query: data => ({ url: `${Endpoints.RESET_PASSWORD}/NewPassword`, method: ApiMethodKeys.POST, data }),
      onQueryStarted(_, { dispatch, queryFulfilled }) {
        queryFulfilled.then(() => {
          dispatch(pushSnackbar({ type: SnackbarKeys.SUCCESS, title: notificationsMsgs.RESET_PASSWORD }));
          dispatch(closeDialog());
        });
      },
    }),
    declineResetPassword: builder.mutation<void, QueryParameters>({
      query: data => ({ url: `${Endpoints.RESET_PASSWORD}/Decline`, method: ApiMethodKeys.POST, data }),
      onQueryStarted(_, { dispatch, queryFulfilled }) {
        queryFulfilled.then(() => {
          dispatch(closeDialog());
        });
      },
    }),
  }),
});

export const {
  useForgotPasswordMutation,
  useResetPasswordMutation,
  useChangePasswordMutation,
  useDeclineResetPasswordMutation,
} = resetPasswordApi;
